import {gql} from "@irati/utils/gql"

const query = gql`
  query NotificationCount($channel: NotificationChannel!, $kind: NotificationKind!) {
    notificationCount(channel: $channel, kind: $kind)
  }
`

export default query
